import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Card } from "react-bootstrap";
import CardHeader from "../../pagecomponents/Elements/Card/CardHeader";
import { getProfileData, updateProfileData as updateProfileAction } from "../../redux/slices/ProfileSlice";
import { CCol, CFormInput, CFormLabel } from "@coreui/react";
import PageWrapper from "../../pagecomponents/Common/PageWrapper";
import CurrencyDropdown from "../../pagecomponents/Common/CurrencyDrodown";
import { ToastContainer } from "react-toastify";
import { toastMessage } from "../../helpers/utility";

const Profile = () => {
  const dispatch = useDispatch();
  const PARAMS = { staff_Id: "1" };
  const [currency, setCurrency] = useState("QAR");

  const PROFILE_DETAILS = {
    staff_Name: "",
    staff_Password: "",
    staff_Email: "",
    staff_Id: "",
    staff_Mobile: "",
    staff_Designation: "",
  };

  const [updatedProfileData, setUpdatedProfileData] = useState(PROFILE_DETAILS);

  const getProfileDetails = async () => {
    const { payload } = await dispatch(getProfileData({ inputData: PARAMS }));
    if (payload?.status !== "error") {
      setUpdatedProfileData(payload.data[0]);
    }
  };

  const updateProfileDetails = async () => {
    const { payload } = await dispatch(updateProfileAction({ inputData: updatedProfileData }));
    if (payload?.status === "success") {
      setUpdatedProfileData(payload);
      toastMessage("success", payload.msg || "Profile Successfully Updated");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedProfileData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    getProfileDetails();
  }, []);

  return (
    <>
      <ToastContainer/>
      <PageWrapper pageName="Manage Profile">
        <Row className="row-sm">
          <Col xl={12}>
            <Card.Body className="min-vh-100">
              <div className="form-group">
                <Row className="row-xs mb-2">
                  <CCol md={6}>
                    <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="staff_Name">
                      Name
                    </CFormLabel>
                    <CFormInput
                      type="text"
                      id="staff_Name"
                      name="staff_Name"
                      value={updatedProfileData.staff_Name}
                      onChange={handleChange}
                    />
                  </CCol>
                  <CCol md={6}>
                    <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="staff_Email">
                      Email
                    </CFormLabel>
                    <CFormInput
                      type="email"
                      id="staff_Email"
                      name="staff_Email"
                      value={updatedProfileData.staff_Email}
                      onChange={handleChange}
                    />
                  </CCol>
                </Row>

              <Row className="row-xs mb-2">
                <CCol md={6}>
                  <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="staff_Mobile">
                    Mobile
                  </CFormLabel>
                  <CFormInput
                    type="text"
                    id="staff_Mobile"
                    name="staff_Mobile"
                    value={updatedProfileData.staff_Mobile}
                    onChange={handleChange}
                  />
                </CCol>
                <CCol md={6}>
                  <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="staff_Designation">
                    Designation
                  </CFormLabel>
                  <CFormInput
                    type="text"
                    id="staff_Designation"
                    name="staff_Designation"
                    value={updatedProfileData.staff_Designation}
                    onChange={handleChange}
                  />
                </CCol>
              </Row>
              {/* <Row className="row-xs mb-2">
                <CCol md={6}>
                  <CurrencyDropdown value={currency} onChange={(val) => setCurrency(val)}></CurrencyDropdown>
                </CCol>
              </Row> */}

                <button className="btn btn-primary mt-3" onClick={updateProfileDetails}>
                  Save Changes
                </button>
              </div>
            </Card.Body>
          </Col>
        </Row>
      </PageWrapper>
    </>
  );
};

export default Profile;
